import Decimal from 'decimal.js-light';
import { PAYMENT_METHODS } from '@/helpers/cash';
import i18n from '@/i18n';

const { t } = i18n;

export const getProcessingTime = (method) => {
  switch (method) {
    case PAYMENT_METHODS.bank:
      return t('funds:utils.one_three_days');
    case PAYMENT_METHODS.card:
    case PAYMENT_METHODS.revolut_ob:
      return t('funds:utils.instant');
    default:
      return t('funds:utils.one_three_days');
  }
};

export const getApproxTopUpFee = method => {
  switch (method) {
    case PAYMENT_METHODS.bank:
      return t('funds:utils.no_fee');
    case PAYMENT_METHODS.card:
      return t('funds:utils.fee_of', { text: '€15.48–€33.85'});
    case PAYMENT_METHODS.revolut_ob:
      return t('funds:utils.fee_of', { text: '€0.18' });
    default:
      return '';
  }
};

export const calculateFee = (totalAmount, amount) => {
  if (!totalAmount || !amount) {
    return null;
  }
  return new Decimal(totalAmount).sub(amount).toNumber();
};
